<template>
  <div class="park-pendingagent">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!--编辑信息-->
    <Drawer
      :title="title"
      v-model="showModalStatus4"
      width="600"
      :mask-closable="false"
      :styles="styles"
    >
      <Form :model="agents" :label-width="60" ref="agentsValidate" :rules="agentsValidate">
        <FormItem label="uuid" label-position="top">{{ agents.id }}</FormItem>
        <FormItem label="昵称" label-position="top">{{ agents.nickname }}</FormItem>
        <FormItem label="手机号" label-position="top">{{ agents.phone }}</FormItem>
        <FormItem label="姓名" label-position="top" prop="name">
          <Input v-model="agents.name"></Input>
        </FormItem>
        <FormItem label="代理类型" label-position="top" prop="type">
          <Select v-model="agents.type" clearable filterable placeholder="代理类型">
            <Option :value="1">导游</Option>
            <Option :value="2">民宿</Option>
            <Option :vlaue="3">景点</Option>
          </Select>
        </FormItem>
        <FormItem label="简介" prop="describe">
          <Input v-model="agents.describe" type="textarea" :rows="4" placeholder="简介..."></Input>
        </FormItem>
        <FormItem label="身份证正面照" prop="imageface">
          <upload-thumb
            v-model="agents.imageface"
            ref="imagefaceuploadthumb"
            :defaultList="imagefacethumblist"
            :autoCropWidth="100" :autoCropHeight="100"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="身份证反面照" prop="imageback">
          <upload-thumb
            v-model="agents.imageback"
            ref="imagebackuploadthumb"
            :defaultList="imagebackthumblist"
            :autoCropWidth="100" :autoCropHeight="100"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:100*100,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
        <FormItem label="营业执照照片" prop="company_photo">
          <upload-thumb
            v-model="agents.company_photo"
            ref="uploadthumb"
            :defaultList="thumblist"
            :autoCropWidth="154" :autoCropHeight="154"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="showModalStatus4 = false">取消</Button>
        <Button type="primary" @click="editagentinfo('agentsValidate')">提交</Button>
      </div>
    </Drawer>
    <!--审核-->
    <Modal v-model="showModalStatus3" title="审核" @on-ok="updateStatus()" :loading="loading">
      <Form :model="review" action="javascript:void(0)">
        <FormItem label="状态">
          <Select v-model="review.status" clearable filterable placeholder="审核状态">
            <Option :value="0">待审核</Option>
            <Option :value="1">通过审核</Option>
            <Option :value="2">未通过审核</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";
export default {
  name: "park-pendingagent",
  data() {
    return {
      id: null, // 页面agentid
      loading: true,
      dataloading: true,
      title: "",
      isable: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      agents: {},
      review: {},
      imagefacethumblist: [], // 身份证是正面
      imagebackthumblist: [], // 身份证反面
      thumblist: [], // 营业执照
      isClear: false,
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      tablelist1: [],
      columns2: [
        {
          type: "selection",
          width: 100,
          fixed: "left"
        },
        {
          title: "代理商UUID",
          key: "agent_uuid",
          minWidth: 100
        },
        {
          title: "名称",
          key: "name",
          minWidth: 160
        }
      ],
      columns2List: [],
      pages1: {
        page: 1,
        size: 10
      },
      pages2: {
        page: 1,
        size: 10
      },
      search_s: {},
      list: [
        {
          title: "用户ID",
          key: "agent_uuid",
          minWidth: 150
        },
        {
          title: "电话",
          key: "username",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.agent != null ? params.row.agent.phone : ""
            );
          }
        },
        {
          title: "用户名称",
          key: "name",
          width: 200,
          render: (h, params) => {
            return h(
              "span",
              params.row.agent != null ? params.row.agent.name : ""
            );
          }
        },
        {
          title: "云支付分销比例",
          key: "underline_fx",
          width: 160
        },
        {
          title: "商城分销比例",
          key: "on_fx",
          width: 160
        },
        {
          title: "操作",
          key: "action",
          width: 350,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.park_uuid, params.row.agent_uuid);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.egentdetail(params.row.agent_uuid);
                    }
                  }
                },
                "编辑"
              ),

              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showreview(
                        params.row.park_uuid,
                        params.row.agent_uuid
                      );
                    }
                  }
                },
                "审核"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      dataInfo: {
        underline_fx: 100,
        on_fx: 100
      },
      agentsValidate: {
        name: [{ required: true, message: "姓名必须填写", trigger: "change" }],
        type: [
          {
            required: true,
            message: "请选择代理类型",
            trigger: "change",
            type: "integer"
          }
        ],
        describe: [
          { required: true, message: "简介必须填写", trigger: "change" }
        ],
        imageface: [
          { required: true, message: "请上传身份证正面", trigger: "change" }
        ],
        imageback: [
          { required: true, message: "请上传身份证反面", trigger: "change" }
        ],
        company_photo: [
          { required: true, message: "请上传营业执照", trigger: "change" }
        ]
      },
      showModalStatus3: false,
      showModalStatus4: false
    };
  },
  created: function() {
    this.id = this.$route.params.id;
    this.getTableList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  watch: {
    "$route.params.id": function(curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function() {
      this.$api.park
        .pendingagent({
          page: this.pages.page,
          size: this.pages.size,
          id: this.id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        id: this.id
      };
      this.$api.park.pendingagent(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    handleSelectRow(selection, index) {
      this.selected = this.$refs.selection.getSelection();
      console.log(this.selected);
    },
    //选中提交
    ok() {
      this.tablelist1 = this.selected;
      this.$api.park
        .agentCreate({ park_uuid: this.id, agentUuidArrs: this.selected })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.$Message.success(res.msg);
            this.showModalStatus = false;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    // 代理商详情
    egentdetail(index) {
      this.agents = {
        id: null,
        nickname: "",
        phone: "",
        name: "",
        type: 0,
        describe: "",
        imageface: "",
        imageback: "",
        company_photo: ""
      };
      this.imagefacethumblist = [];
      this.imagebackthumblist = [];
      this.thumblist = [];

      this.$refs["agentsValidate"].resetFields();

      this.showModalStatus4 = !this.showModalStatus4;
      this.agents.id = index;
      this.$api.agents.detail({ id: index }).then(res => {
        this.agents.id = res.result.agent_uuid;
        this.agents.name = res.result.name;
        this.agents.nickname = res.result.userdata.nickname;
        this.agents.type = res.result.type;
        this.agents.phone = res.result.phone;
        this.agents.describe = res.result.describe;
        this.agents.status = res.result.status;
        let imgsArr =
          res.result.image == null ? [] : res.result.image.split(",");
        for (var i = 0; i < imgsArr.length; i++) {
          if (i == 0) {
            this.agents.imageface = res.result.image.split(",")[0];
            this.imagefacethumblist.push({
              name: res.result.image.split(",")[0],
              url: res.result.image.split(",")[0],
              status: "finished"
            });
          }

          if (i == 1) {
            this.agents.imageback = res.result.image.split(",")[1];
            this.imagebackthumblist.push({
              name: res.result.image.split(",")[1],
              url: res.result.image.split(",")[1],
              status: "finished"
            });
          }
        }

        this.agents.company_photo = res.result.company_photo;
        this.thumblist.push({
          name: res.result.company_photo,
          url: res.result.company_photo,
          status: "finished"
        });
      });
    },
    // 修改代理商信息
    editagentinfo(name) {
      if (this.$refs["imagefaceuploadthumb"].uploadList.length > 0) {
        this.agents.imageface = this.$refs[
          "imagefaceuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.imageface = "";
      }
      if (this.$refs["imagebackuploadthumb"].uploadList.length > 0) {
        this.agents.imageback = this.$refs[
          "imagebackuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.imageback = "";
      }
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.agents.company_photo = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.agents.company_photo = "";
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {};
          params.id = this.agents.id; //是	string	代理商户UUID
          params.type = this.agents.type; //是	int	商户类型1导游2民宿3景点
          params.name = this.agents.name; //否	string	姓名
          params.status = 0; //否	string	审核状态
          params.describe = this.agents.describe; //否	string	简介
          params.image = this.agents.imageface + "," + this.agents.imageback; //否	string	身份证正反图集
          params.company_photo = this.agents.company_photo; //否	string	营业执照
          this.$api.agents.edit(params).then(res => {
            // console.log(this.agents);
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showModalStatus4 = !this.showModalStatus4;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(park_uuid, agent_uuid) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.park
            .agentRemove({ agent_uuid: agent_uuid, park_uuid: park_uuid })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    // 审核
    showreview: function(park_uuid, agent_uuid) {
      // 弹出确认框
      this.agent_uuid = agent_uuid;
      this.park_uuid = park_uuid;
      this.showModalStatus3 = !this.showModalStatus3;
    },
    // 审核
    updateStatus: function(name) {
      this.$api.park
        .reviewagent({
          status: this.review.status,
          agent_uuid: this.agent_uuid,
          park_uuid: this.park_uuid
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.showModalStatus3 = !this.showModalStatus3;
            this.getTableList();
          }
        });
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
